









import Vue, { PropType } from 'vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'
import BaseDescription from '../../components/base/BaseDescription.vue'
import SectionHeading from '../Home/SectionHeading.vue'
import Post from '../../components/Domain/Lift/LiftPost.vue'
import PostSection from '../../components/Domain/Lift/ListPostSection.vue'

export default Vue.extend({
  name: 'Story',
  components: { PostSection, Post, SectionHeading, BaseDescription, TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    },
    right: Boolean as PropType<boolean>
  }
})
